module.exports = __webpack_public_path__ + "static/media/icon-logo.2a116063f1f53e96383648d78815019d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-logo.png
// module id = 1169
// module chunks = 1